import { useRouter } from 'next/router'
import { ReactNode, useEffect, VFC } from 'react'
import { IntercomProvider as Provider, useIntercom } from 'react-use-intercom'
import { INTERCOM_APP_ID } from 'src/utils/env'
import { MESSAGES } from 'src/utils/routes'

export const IntercomProvider: VFC<{ children: ReactNode }> = ({
  children,
}) => (
  <>
    <Provider appId={INTERCOM_APP_ID}>
      <IntercomLoader />
      {children}
    </Provider>
  </>
)

const INTERCOM_DISABLED_PATHS = [MESSAGES]

const IntercomLoader: VFC = () => {
  const { pathname } = useRouter()
  const { boot, shutdown } = useIntercom()
  useEffect(() => {
    if (INTERCOM_DISABLED_PATHS.includes(pathname)) {
      shutdown()
      return
    }
    boot()
  }, [pathname, boot, shutdown])
  return <></>
}
